import qs from 'qs';
import { config as envConfig } from 'ENV_CONFIG';
import { services } from '~/ocab-services/services.constant';

const getFromQueryParam = () => qs.parse(window.location.search, { ignoreQueryPrefix: true }).appointmentTypeId;

export const getAppointmentsDetails = (appointmentType) => {
  const appointmentTypeId = appointmentType.id ? appointmentType.id : getFromQueryParam();
  const journey = envConfig.services[services.HOME_SERVICES.name].appointmentTypes[appointmentTypeId]?.analyticsJourneyName;
  return {
    journey,
    branchId: '',
  };
};
